import type { AuthRole } from '@/shared/constants'
import { AdminScopeType } from '@/shared/constants'
import { isSuperAdminRole, isTenantAdminRole } from '@/shared/libs/admin-routes'
import { useAuthStore } from '@/shared/store/auth-store'

export function useAdminScope() {
  const user = useAuthStore((state) => state.user)
  const activeTenantId = useAuthStore((state) => state.activeTenantId)
  const activeTenantSlug = useAuthStore((state) => state.activeTenantSlug)
  const setActiveTenantId = useAuthStore((state) => state.setActiveTenantId)
  const setActiveTenantSlug = useAuthStore((state) => state.setActiveTenantSlug)
  const logout = useAuthStore((state) => state.logout)
  const role = user?.role as AuthRole | undefined
  const isSuperAdmin = isSuperAdminRole(role)
  const isTenantAdmin = isTenantAdminRole(role)
  const scopeType = isSuperAdmin ? AdminScopeType.Super : AdminScopeType.Tenant
  const tenantId = activeTenantId ?? user?.tenantId ?? null
  const tenantSlug = activeTenantSlug ?? user?.tenantSlug ?? null

  return {
    activeTenantId: activeTenantId ?? '',
    activeTenantSlug: activeTenantSlug ?? '',
    isSuperAdmin,
    isTenantAdmin,
    logout,
    role,
    setActiveTenantId,
    setActiveTenantSlug,
    scopeType,
    tenantId,
    tenantSlug,
    user,
  }
}
